import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Tag, Icon } from 'core/components';
import { ALERT_STATE_LABELS } from '@kentik/ui-shared/alerting/constants';

const TransitionTag = styled(Tag)`
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1em;
  font-size: 10px;
  font-weight: 600;
  padding: 0.5em 1em;
  align-items: center;
  transition:
    background-color 400ms ease,
    color 400ms ease,
    border-color 400ms ease;
`;

const FadingContent = styled.span`
  display: flex;
  transition: opacity 200ms ease;
  opacity: ${({ $fading }) => ($fading ? 0 : 1)};
  align-items: center;
  justify-content: center;
  line-height: 12px;
`;

const INTENT = { active: 'danger', checking: 'success', cleared: 'none' };
const LABEL = { active: ALERT_STATE_LABELS.alarm, cleared: ALERT_STATE_LABELS.clear };

export default function AlertStatusTag({ isActive }) {
  const [status, setStatus] = useState(isActive ? 'active' : 'cleared');
  const [fading, setFading] = useState(false);
  const prevIsActive = useRef(isActive);
  const timers = useRef([]);

  useEffect(() => {
    if (prevIsActive.current !== isActive) {
      prevIsActive.current = isActive;

      timers.current.forEach(clearTimeout);
      timers.current = [];

      const schedule = (fn, delay) => {
        const id = setTimeout(fn, delay);
        timers.current.push(id);
      };

      if (!isActive) {
        setFading(true);
        schedule(() => {
          setStatus('checking');
          setFading(false);
        }, 200);
        schedule(() => setFading(true), 1000);
        schedule(() => {
          setStatus('cleared');
          setFading(false);
        }, 1200);
      } else {
        setFading(true);
        schedule(() => {
          setStatus('active');
          setFading(false);
        }, 200);
      }
    }

    return () => timers.current.forEach(clearTimeout);
  }, [isActive]);

  return (
    <div>
      <TransitionTag intent={INTENT[status]} minWidth={72} alignSelf="center">
        <FadingContent $fading={fading}>
          {status === 'checking' ? <Icon icon="tick" iconSize={12} /> : LABEL[status]}
        </FadingContent>
      </TransitionTag>
    </div>
  );
}
